<div id="chip-select-component-wrapper">
  <div class="icon-wrapper" [ngClass]="{ 'icon-wrapper-no-icon': !icon }">
    <ion-icon *ngIf="icon" [name]="icon"></ion-icon>
  </div>
  <div id="selectable-chips-container">
    <ng-container *ngFor="let chip of selectableChips">
      <div
        (click)="selectChip($event, chip)"
        [ngClass]="{ 'chip-selected': chip.isSelected, 'chip-unselected': !chip.isSelected, 'chip-disabled': disabled }"
        class="chip"
      >
        <ion-icon *ngIf="chip.isSelected" class="chip-icon" name="checkmark-outline"></ion-icon>
        <div class="chip-Text">{{ chip.displayText }}</div>
      </div>
    </ng-container>
  </div>
</div>
